import * as React from 'react'
// components
import { LoaderWithOverlay } from 'components/UI'
// context
import { StrategyActionsAPIContext } from 'containers/StrategyActions/layers/API'
import { StrategyActionsBLContext } from 'containers/StrategyActions/layers/BL'
// view components
import InfoPanel from './components/InfoPanel'
import FilterPanel from './components/FiltersPanel'
// container
import TasksListContainer from 'containers/StrategyActions/components/TasksList'

const StrategyActions: React.FC = () => {
  const { items, isLoading, plans } = React.useContext(StrategyActionsAPIContext)
  const { isGroupedByPlan } = React.useContext(StrategyActionsBLContext)

  return React.useMemo(
    () => (
      isLoading ? <LoaderWithOverlay isLoading={isLoading} height='100%' /> :
        <div>
          <InfoPanel />
          <FilterPanel />
          {isGroupedByPlan ? (
            plans.map(plan => <TasksListContainer key={plan.id} plan={plan} />)
          ) : (
            <TasksListContainer key={new Date().valueOf()} plan={items} />
          )}
        </div>
    ),
    [isGroupedByPlan, isLoading, plans]
  )
}

export default StrategyActions
